import {
  SHOW_ACCOUNT,
  ENABLE_RENEW,
  DISABLE_RENEW,
  CREATE_SUBSCRIPTION,
  UPDATE_PAYMENT,
  UPDATE_BILLING_PERIOD,
  UPDATE_PAYMENT_AND_SUBSCRIBE,
  UPDATE_TRIAL_AND_SUBSCRIBE,
} from '../content/types';
import { AUTH_USER, AUTH_USER_OUT } from '../auth/types';

import {
  UPDATE_EMAIL,
  AGREE_TO_TERMS,
  TOGGLE_AGREE_TO_TERMS,
  UPDATE_EMAIL_RECEIVES,
  SHOW_USER,
} from './types';

let initialState = {
  user: {
    id: 1,
    email: '',
    receive_emails: true,
    agree_to_terms: false,
    subscription_end_datetime: null,
    formatted_subscription_end_datetime: null,
    subscription_auto_renew: false,
    subscribed: false,
    payment_method_added: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_USER:
      return {
        ...state,
        user: action.payload.user,
      };
      return state;
    case AUTH_USER:
    case SHOW_ACCOUNT:
      return {
        ...state,
        user: action.user,
      };
    case UPDATE_EMAIL:
    case UPDATE_PAYMENT:
    case UPDATE_PAYMENT_AND_SUBSCRIBE:
      return { ...state, user: action.payload };
    case UPDATE_TRIAL_AND_SUBSCRIBE:
      return { ...state, user: action.payload };
    case UPDATE_BILLING_PERIOD:
      return { ...state, user: action.payload };
    case CREATE_SUBSCRIPTION:
    case AGREE_TO_TERMS:
      return {
        ...state,
        user: { agree_to_terms: true },
      };
    case TOGGLE_AGREE_TO_TERMS:
      return {
        ...state,
        user: { agree_to_terms: !state.user.agree_to_terms },
      };
    case ENABLE_RENEW:
      return {
        ...state,
        user: action.payload,
      };
    case DISABLE_RENEW:
      return {
        ...state,
        user: action.payload,
      };
    case AUTH_USER_OUT:
      return {
        ...state,
        user: initialState.user,
      };
    case UPDATE_EMAIL_RECEIVES:
      return {
        ...state,
        user: { ...state.user, receive_emails: !state.user.receive_emails },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/profileDetails/reducer.js